import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { CompanyAddressList } from 'src/app/models/companyAddress/company-address-model';
import { CompanyAddressService } from 'src/app/services/company-address.service';
import { CompanyAddressDeleteComponent } from '../company-address-delete/company-address-delete.component';

@Component({
  selector: 'app-company-address-listing',
  templateUrl: './company-address-listing.component.html',
  styleUrls: ['./company-address-listing.component.css']
})
export class CompanyAddressListingComponent implements OnInit {

  companyAddressListing: Array<CompanyAddressList> = new Array<CompanyAddressList>();
  Loader: boolean = false;

  constructor(private companyAdress: CompanyAddressService, private router: Router, private modalService: NgbModal) { }

  ngOnInit() {
    this.CompanyAddressList();
  }

  CompanyAddressList() {
    this.Loader = true;
    this.companyAdress.GetCompanyAddressList()
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        this.companyAddressListing = responseBody.responseData;
      })
  }

  CompanyAddressUpdate(UpdateCompanyAddressModel) {
    this.router.navigate(['/company-address-update/' + UpdateCompanyAddressModel.id]);
  }

  DeleteAddress(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this.companyAdress.passId(item.id);
    let modalRef = this.modalService.open(CompanyAddressDeleteComponent, modalConfig);
    modalRef.result.then(() => {
    }, (reason) => {
      this.CompanyAddressList();
    })

  }

}
